/**
 * Aufwand einer Entwicklung: gespeichert in Minuten, gezeigt als Stunden und
 * Minuten.
 *
 * Minuten statt Stunden mit Komma, weil sich „1,25 h" niemand als „1 h 15 min"
 * vorstellt — und weil Summen je Woche und Monat in ganzen Minuten exakt
 * bleiben.
 */

/** 90 → "1 h 30 min", 45 → "45 min", 120 → "2 h", leer → "—". */
export const formatEffort = minutes => {
	if (minutes === null || minutes === undefined || Number.isNaN(Number(minutes))) return '—'

	const total = Math.round(Number(minutes))
	const hours = Math.floor(total / 60)
	const rest = total % 60

	if (!hours) return `${rest} min`
	if (!rest) return `${hours.toLocaleString('de-AT')} h`
	return `${hours.toLocaleString('de-AT')} h ${rest} min`
}

/** Minuten in die beiden Felder des Bearbeiten-Fensters zerlegen. */
export const splitEffort = minutes => {
	if (minutes === null || minutes === undefined) return { hours: '', minutes: '' }
	return { hours: String(Math.floor(minutes / 60)), minutes: String(minutes % 60) }
}

/**
 * Die beiden Felder wieder zu Minuten zusammensetzen. Beide leer heißt „nicht
 * geschätzt" (null) — und nicht 0 Minuten: Die Auswertung zählt das getrennt.
 * Unlesbare Eingaben ergeben `undefined`, damit das Fenster nicht speichert.
 */
export const joinEffort = ({ hours, minutes }) => {
	const h = String(hours ?? '').trim()
	const m = String(minutes ?? '').trim()
	if (!h && !m) return null

	const hh = h ? Number(h) : 0
	const mm = m ? Number(m) : 0
	if (![hh, mm].every(value => Number.isInteger(value) && value >= 0)) return undefined

	return hh * 60 + mm
}
